import { render, staticRenderFns } from "./ManterTabelionato.vue?vue&type=template&id=2d97b2cd&scoped=true&"
import script from "./ManterTabelionato.vue?vue&type=script&lang=js&"
export * from "./ManterTabelionato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d97b2cd",
  null
  
)

export default component.exports